import React, { useState, MouseEvent, useEffect } from 'react';
import {
  Button,
  FormControlLabel,
  Paper,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  IconButton,
  Typography,
  Checkbox,
  Tooltip,
} from '@mui/material';
import { Remove as MinusIcon } from '@mui/icons-material';
import DoneIcon from '@mui/icons-material/Done';
import userProfile from '../../../../assets/images/userProfile.svg';
import audiLogDate from '../../../../assets/images/AudiLogDate.svg';
import audiLogUser from '../../../../assets/images/AudiLogUser.svg';
import audiLogEvent from '../../../../assets/images/AudiLogEvent.svg';
import { ReactComponent as SearchIcon } from '../../../../assets/images/Search.svg';
import PaginationComponent from '../../../../components/Pagination';
import createAxiosInstance from '../../../../api';
import { DateRangePicker } from 'react-date-range';
import { startOfMonth, endOfMonth } from 'date-fns';
import { format } from 'date-fns';
import { closeBlackIcon } from '../../../../assets/images';
import emptyFolter from '../../../../assets/images/empty-folder 2.svg';

const AudiLog = (userDetails: any) => {
  interface UserData {
    profile: string;
    name: string;
    event: string;
    updated: string;
    nameSearched: boolean;
    id: number;
  }

  interface EventData {
    id: number;
    event: string;
  }

  interface Filter {
    roleIDs: string[];
  }

  interface Role {
    roleID?: string | number;
    roleName?: string;
  }
  const dummyData: string[] = [
    'Login Event',
    'Update Information Event',
    'Device Register Event',
    'Share Device Event',
    'Device Update Event',
  ];
  const userimage = userProfile;

  const axiosInstance = createAxiosInstance();
  const [auditdata, setAuditdata]: any = useState<Role[]>([]);
  const [auditerror, setauditerror] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedData, setSelectedData]: any = useState<string[]>([]);
  const [selectedDate, setSelectedDate] = useState<number[]>([1]);
  const [userAnchorEl, setUserAnchorEl] = useState<null | HTMLElement>(null);
  const [dateAnchorEl, setDateAnchorEl] = useState<null | HTMLElement>(null);
  const [eventAnchorEl, setEventAnchorEl] = useState<null | HTMLElement>(null);
  const [filteredData, setFilteredData]: any = useState<string[]>(dummyData);
  const [selectedusername, setSelectedusername] = useState<number[]>([]);
  const [seeMoreIndex, setSeeMoreIndex] = useState<number>(2);

  const [eventNameQuery, setEventNameQuery]: any = useState<string>('');
  const [filteredEvent, setFilteredEvent] = useState<EventData[]>(filteredData);
  const [initialEventData, setInitialEventData] =
    useState<string[]>(filteredData);
  const [filterPayload, setFilterPayload] = useState<null | any>(null);
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    filterPayload
      ? fetchFilterDate(filterPayload, page, rowsPerPage)
      : getAuditData(page, rowsPerPage, rowsPerPage, eventNameQuery);
  };
  const startToday = new Date();
  startToday.setHours(0, 0, 0, 0);
  const startOfCurrentMonth = startOfMonth(new Date());
  const endOfCurrentMonth = endOfMonth(new Date());

  const [selectionRange, setSelectionRange] = useState({
    startDate: startOfCurrentMonth,
    endDate: endOfCurrentMonth,
    key: 'selection',
  });

  const handleSelect = (ranges: any) => {
    setSelectionRange({
      ...ranges.selection,
      startDate: new Date(ranges.selection.startDate.setHours(0, 0, 0, 0)), // Reset start to 00:00:00
      endDate: new Date(ranges.selection.endDate.setHours(23, 59, 59, 999)), // Reset end to 23:59:59
    });
    setCurrentPage(1);
  };
  const handleRowsPerPageChange = (value: number) => {
    filterPayload
      ? fetchFilterDate(filterPayload, currentPage - 1, value)
      : getAuditData(currentPage - 1, value);
    setRowsPerPage(value);
    setCurrentPage(1);
  };
  useEffect(() => {
    // Define the initial payload object
    const payload = {
      from: selectionRange.startDate.toISOString(),
      to: selectionRange.endDate.toISOString(),
    };

    if (selectionRange || selectedData?.length > 0) {
      fetchFilterDate(payload);
      setFilterPayload(payload);
    } else {
      setFilterPayload(null);
    }
    setSeeMoreIndex(selectedData?.length);
  }, [selectedDate, selectedData, selectionRange]);

  const fetchFilterDate = async (
    payload?: any,
    pagenumber?: number,
    row_perpage?: number,
  ) => {
    await axiosInstance
      .post('/customers/selfAudit', {
        from: payload.from ? payload.from : null,
        to: payload.from ? payload.to : null,
        // eventNames:
        //   initialEventData?.length > 0
        //     ? initialEventData
        //     : selectedData
        //       ? selectedData
        //       : '',
        eventNames: selectedData,
        limit: row_perpage ? row_perpage : rowsPerPage,
        offset: pagenumber
          ? (pagenumber - 1) * rowsPerPage
          : (currentPage - 1) * rowsPerPage,
      })
      .then((response) => {
        setAuditdata(response.data.data);

        const uniqueEventNames = [
          ...new Set(response.data.data.map((item: any) => item.event)),
        ];

        // setFilteredData(uniqueEventNames);
        // setFilteredData(['Login Event', 'Create Role', 'Reset Event']);

        setauditerror(false);

        setTotalPages(
          Math.ceil(
            response.data.count / (row_perpage ? row_perpage : rowsPerPage),
          ),
        );
      })
      .catch((error) => {
        setAuditdata([]);
        setauditerror(true);
      });
  };
  const handleChange = (username: any): void => {
    setInitialEventData([]);
    if (username) {
      if (selectedData.includes(username)) {
        const updatedData = selectedData.filter(
          (item: any) => item !== username,
        );
        setSelectedData(updatedData);
      } else {
        const adddata = [...selectedData, username];
        const uniqueEventNames = [...new Set(adddata)];
        setSelectedData(uniqueEventNames);
      }
    } else {
      return;
    }
    setCurrentPage(1);
  };

  const handledate = (dateId: number | string): void => {
    if (typeof dateId === 'number') {
      if (selectedDate.includes(dateId)) {
        setSelectedDate([]);
      } else {
        setSelectedDate([dateId]);
      }
    }
    setCurrentPage(1);
  };

  const handleDateClick = (event: MouseEvent<HTMLElement>): void => {
    setDateAnchorEl(event.currentTarget);
  };

  const handleEventClick = (event: MouseEvent<HTMLElement>): void => {
    setEventAnchorEl(event.currentTarget);
  };

  const handleDateClose = () => {
    setDateAnchorEl(null);
  };

  const handleEventClose = () => {
    setEventAnchorEl(null);
  };

  const handleEventNameSearchChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const query = event.target.value;
    setEventNameQuery(query);

    const filtered = filteredData.filter((item: any) =>
      item.toLowerCase().includes(query.toLowerCase()),
    );
    setFilteredEvent(filtered);
  };

  const getAuditData = async (
    pagenumber?: number,
    row_perpage?: number,
    search: unknown = '',
    filters: Filter[] | undefined = [],
    eventName = '',
    // sort: Sort | undefined = { orderBy: 'name', order: 'asc' },
  ) => {
    const setfilter = filters?.length > 0 ? { roleIDs: filters } : {};

    await axiosInstance
      .post('/selfAudits', {
        // search: search,
        // sort: sort,
        filters: setfilter,
        limit: row_perpage ? row_perpage : rowsPerPage,
        offset: pagenumber
          ? (pagenumber - 1) * rowsPerPage
          : (currentPage - 1) * rowsPerPage,
      })
      .then((response) => {
        setAuditdata(response.data.data);

        const uniqueEventNames = [
          ...new Set(response.data.data.map((item: any) => item.event)),
        ];

        // setFilteredData(uniqueEventNames);

        setTotalPages(
          Math.ceil(
            response.data.count / (row_perpage ? row_perpage : rowsPerPage),
          ),
        );
        setauditerror(false);
      })
      .catch(() => {
        setAuditdata([]);
        setauditerror(true);
      });
  };

  useEffect(() => {
    if (!filterPayload && !(selectedDate?.length > 0)) {
      getAuditData();
    }
  }, [filterPayload]);

  function formatDate(isoDate: any) {
    const months = [
      'JAN',
      'FEB',
      'MAR',
      'APR',
      'MAY',
      'JUN',
      'JUL',
      'AUG',
      'SEP',
      'OCT',
      'NOV',
      'DEC',
    ];

    const date = new Date(isoDate);
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  }

  function formatTime(isoDate: any): string {
    const date = new Date(isoDate);
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${hours}:${minutes}:${seconds}`;
  }

  const userOpen = Boolean(userAnchorEl);
  const userId = userOpen ? 'simple-popover' : undefined;
  const dateOpen = Boolean(dateAnchorEl);
  const dateId = dateOpen ? 'simple-popover' : undefined;
  const eventOpen = Boolean(eventAnchorEl);
  const eventId = eventOpen ? 'simple-popover' : undefined;

  const changeFormat = (date: number | Date) => {
    return format(date, 'MMM d, yyyy');
  };

  return (
    <>
      <div className="content  global_audilog user_management">
        <div className="global_audilog_header">
          <Button
            className="global_audilog_date-btn global_buttons"
            aria-describedby={dateId}
            onClick={handleDateClick}
          >
            <img src={audiLogDate} width={24} alt="date img" />
            <Typography>Period</Typography>
          </Button>
          <Button
            className={
              selectedData?.length > 0
                ? 'global_audilog_event_name-btn global_buttons global_buttons-active'
                : 'global_audilog_event_name-btn global_buttons'
            }
            aria-describedby={eventId}
            onClick={handleEventClick}
          >
            <img src={audiLogEvent} width={24} alt="event img" />
            <Typography>Event Name</Typography>
            <div className="global_buttons-filtercount">
              <p>{selectedData?.length}</p>
            </div>
          </Button>
        </div>
        <section className="global_buttons_filtered-name">
          <div className="auditlog_date_range">
            {changeFormat(selectionRange?.startDate) +
              ' - ' +
              changeFormat(selectionRange?.endDate)}
          </div>
          <div>
            {selectedData
              ?.slice(0, seeMoreIndex)
              ?.map((event: any, index: React.Key | null | undefined) => (
                <div key={index} className="filterlist">
                  <p>{event}</p>
                  <Button onClick={() => handleChange(event)}>
                    <img src={closeBlackIcon} alt="Delete Icon" width={13} />
                  </Button>
                </div>
              ))}
            {selectedData?.length > 2 && seeMoreIndex === 2 && (
              <div className="see_more_data">
                <Button
                  onClick={() => setSeeMoreIndex(selectedData?.length)}
                >{`+${selectedData?.length - 2} More`}</Button>
              </div>
            )}
            {selectedData?.length > 2 && seeMoreIndex !== 2 && (
              <div className="see_more_data">
                <Button onClick={() => setSeeMoreIndex(2)}>show less</Button>
              </div>
            )}
          </div>
        </section>

        <TableContainer
          className="global_audilog_table-container"
          component={Paper}
        >
          <Table>
            <TableHead className="global_audilog_table-heading">
              <TableRow>
                <TableCell className="global_audilog_event-name">
                  <Typography>User</Typography>
                </TableCell>
                <TableCell className="global_audilog_event-name">
                  <Typography>Event Name</Typography>
                </TableCell>
                <TableCell className="global_audilog_user-name">
                  <Typography>Event Description</Typography>
                </TableCell>
                <TableCell className="global_audilog_update">
                  <Typography>Last Updated</Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {auditdata &&
                auditdata?.map((user: any, index: any) => (
                  <TableRow key={index}>
                    <TableCell>
                      <div className="global_audilog_user-img">
                        <img
                          src={user?.avatar ? user?.avatar : userProfile}
                          width={40}
                          alt="User Profile"
                        />
                        <Typography>{user?.userName}</Typography>
                      </div>
                    </TableCell>
                    <TableCell>
                      <Typography>{user?.event}</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography>
                        {user?.eventDescription?.length > 30 ? (
                          <Tooltip title={user?.eventDescription} arrow>
                            <span>
                              {user?.eventDescription?.slice(0, 30)}....
                            </span>
                          </Tooltip>
                        ) : (
                          user?.eventDescription?.slice(0, 30) || ''
                        )}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography>
                        {formatDate(user.eventTime) +
                          ' ' +
                          formatTime(user.eventTime)}
                      </Typography>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        {!(auditdata?.length > 0) && (
          <div className="global_audilog-nodata">
            <img src={emptyFolter} alt="nodata" width="120" height="120" />
            <h3>No Record Found!</h3>
          </div>
        )}

        {auditdata && auditdata?.length > 0 && (
          <PaginationComponent
            rowsPerPageOptions={[5, 10, 20, 30]}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            totalPages={totalPages}
          />
        )}

        <Popover
          className="popover-audit"
          id={dateId}
          open={dateOpen}
          anchorEl={dateAnchorEl}
          onClose={handleDateClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
        >
          <div>
            <DateRangePicker
              ranges={[selectionRange]}
              onChange={handleSelect}
            />
          </div>
        </Popover>

        <Popover
          className="popover-audit"
          id={eventId}
          open={eventOpen}
          anchorEl={eventAnchorEl}
          onClose={handleEventClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
        >
          <div className="user_name-popover">
            <div className="user_name-popover-search">
              <TextField
                className="user_name-popover-search_input search-input"
                variant="outlined"
                placeholder="Search event names here"
                fullWidth
                InputProps={{
                  startAdornment: <SearchIcon className="search_icon" />,
                }}
                value={eventNameQuery}
                onChange={handleEventNameSearchChange}
              />
            </div>
            <div className="event-popover">
              {filteredEvent &&
                filteredEvent.map((user: any, index: any) => {
                  return (
                    <div
                      key={index}
                      className={
                        selectedData.includes(user)
                          ? 'role-popover-checkbox role-popover-checkbox_active'
                          : 'role-popover-checkbox'
                      }
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={selectedData.includes(user)}
                            onChange={() => {
                              handleChange(user);
                            }}
                          />
                        }
                        label={user}
                      />
                    </div>
                  );
                })}
            </div>
          </div>
        </Popover>
      </div>
    </>
  );
};

export default AudiLog;
